import { useGLTF } from "@react-three/drei";
import { BaseAnimationWithAssetProps } from "./types";

const Asset3DWithNoAnimation = ({
  transform3D,
  asset,
}: BaseAnimationWithAssetProps) => {
  const { scene } = useGLTF(asset.url);
  return (
    <primitive
      object={scene}
      position={transform3D?.position}
      rotation={transform3D?.rotation}
      scale={transform3D?.scale}
    />
  );
};

export default Asset3DWithNoAnimation;
